module.exports = __webpack_public_path__ + "images/emoji/fuelpump.d74ea9d9afce240b236d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/fuelpump.png
// module id = Yu1S
// module chunks = 1